
import type { State } from '../types';

import type CollaboratorCollection from '../../models/CollaboratorCollection';
import type CollaboratorInviteCollection from '../../models/CollaboratorInviteCollection';
import type TimelineEventCollection from '../../models/TimelineEventCollection';

export function getCollaborators(state: State): CollaboratorCollection {
  return state.collaborators.collaborators;
}

export function isFetchingCollaborators(state: State): boolean {
  return state.collaborators.isFetchingCollaborators;
}

export function getInvites(state: State): CollaboratorInviteCollection {
  return state.collaborators.invites;
}

export function isCreatingCollaborator(state: State): boolean {
  return state.collaborators.isCreatingCollaborator;
}

export function getTimelineEvents(state: State): TimelineEventCollection {
  return state.collaborators.events;
}

export function isFetchingEvents(state: State): boolean {
  return state.collaborators.isFetchingEvents;
}

export function isCreatingEvent(state: State): boolean {
  return state.collaborators.isCreatingEvent;
}



// WEBPACK FOOTER //
// ./src/redux/collaborators/selectors.js